export enum HEADER_MENU_ITEMS {
  SETTINGS = 1,
  CONTACT = 2,
}
